import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { AvatarComponent } from '../../../avatar/avatar.component'

@Component({
  selector: 'app-suggestion-meta',
  standalone: true,
  imports: [AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './suggestion-meta.component.html',
  styleUrl: './suggestion-meta.component.scss',
})
export class SuggestionMetaComponent {
  @Input({ required: true })
  authorName!: string

  @Input()
  createdAtRelative: string | null = null
}
